/* Модуль честного трекинга чистого времени просмотра (HTML5 TimeRanges 75%), проверочных вопросов и выдачи чек-листов */

const LESSON_QUIZZES = {
  1: {
    day: 1,
    title: "Проверочный вопрос к Уроку 1",
    subtitle: "Тема: 4 стихии, тело, здоровье и врожденный темперамент",
    question: "С какой стихией и симптомом в теле у вас чаще всего возникает перегруз / усталость?",
    options: [
      { id: "fire", text: "🔥 Огонь (импульсивность, скачки давления, быстрое эмоциональное выгорание)" },
      { id: "earth", text: "🌍 Земля (гиперконтроль, напряжение в спине и суставах, страх потерять опору)" },
      { id: "air", text: "💨 Воздух (перегруз мыслями, бессонница, расфокус и тревожность)" },
      { id: "water", text: "🌊 Вода (накопление чужих эмоций, отечность, ЖКТ при стрессе, чувство вины)" }
    ],
    checklist: {
      title: "Шпаргалка: Аптечка 4 стихий. Простые действия для тела и сил (PDF)",
      filename: "gayd_4_stihii_metatgbot.pdf",
      url: "/assets/docs/gayd_4_stihii_metatgbot.pdf",
      botParam: "gift_elements"
    }
  },
  2: {
    day: 2,
    title: "Проверочный вопрос к Уроку 2",
    subtitle: "Тема: Семья, отношения, взаимопонимание и личные границы",
    question: "Что сейчас для вас важнее всего наладить в отношениях с партнером или близкими?",
    options: [
      { id: "boundaries", text: "⚖️ Научиться слышать себя и перестать растворяться в интересах других" },
      { id: "claims", text: "💬 Вернуть тепло, открытый диалог и избавиться от постоянных обид и недомолвок" },
      { id: "fear", text: "💔 Отпустить прошлый болезненный опыт и перестать бояться новых отношений" },
      { id: "harmony", text: "✨ Укрепить существующий союз и научиться по-настоящему доверять друг другу" }
    ],
    checklist: {
      title: "Астрологический гайд: Идеальный партнёр по судьбе (14 стр., PDF)",
      filename: "checklist_os_1_7_metatgbot.pdf",
      url: "/assets/docs/checklist_os_1_7_metatgbot.pdf",
      botParam: "gift_day2"
    }
  },
  3: {
    day: 3,
    title: "Проверочный вопрос к Уроку 3",
    subtitle: "Тема: Деньги, самооценка, уверенность и внутреннее право зарабатывать",
    question: "Что сейчас больше всего сдерживает рост вашего дохода и благополучия?",
    options: [
      { id: "ceiling", text: "📈 Неловко называть достойную цену за свой труд и заявлять о себе" },
      { id: "leak", text: "💸 Деньги приходят, но тут же утекают на непредвиденные траты и долги" },
      { id: "cushion", text: "🛡️ Фоновая тревога за будущее и страх остаться без средств" },
      { id: "pro", text: "🎓 Хочу освоить точный практический навык и стабильно зарабатывать на астрологии" }
    ],
    checklist: {
      title: "Астрологический гайд: Денежная Венера. Финансовый рост и уверенность (PDF)",
      filename: "Денежная_Венера_Гайд_День_3.pdf",
      url: "/assets/docs/gayd_denezhnaya_venera_den_3.pdf",
      botParam: "gift_day3"
    }
  }
};

// Расчет чистого времени воспроизведения без учета перемоток через HTML5 TimeRanges
function calculatePureWatchedSeconds(video) {
  if (!video || !video.played) return 0;
  let total = 0;
  try {
    const count = video.played.length;
    for (let i = 0; i < count; i++) {
      total += (video.played.end(i) - video.played.start(i));
    }
  } catch (e) {
    total = video.currentTime || 0;
  }
  return Math.max(0, total);
}

function formatMinutesAndSeconds(seconds) {
  const s = Math.max(0, Math.floor(seconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, '0')}`;
}

// Инициализация телеметрии плеера для текущей страницы урока
function initVideoTracking() {
  const path = window.location.pathname;
  let dayNum = null;
  if (path.includes('day-1')) dayNum = 1;
  else if (path.includes('day-2')) dayNum = 2;
  else if (path.includes('day-3')) dayNum = 3;
  else if (path.includes('day-4')) dayNum = 4;

  if (!dayNum) return;

  const video = document.querySelector('video') || document.getElementById(`day${dayNum}InlineVideo`);
  const card = document.getElementById(`day${dayNum}VideoCard`) || document.querySelector('.inline-video-card');
  if (!video || !card) return;

  const quiz = LESSON_QUIZZES[dayNum];
  const storagePosKey = `meta_video_pos_day_${dayNum}`;
  const storagePureKey = `meta_video_pure_day_${dayNum}`;
  const storageCompletedKey = `meta_day_${dayNum}_completed`;
  const storageAnsweredKey = `meta_day_${dayNum}_answered`;

  // 1. Создаем или находим контейнер телеметрии под плеером
  let telemetryBox = document.getElementById('videoWatchTelemetryBox');
  if (!telemetryBox) {
    telemetryBox = document.createElement('div');
    telemetryBox.id = 'videoWatchTelemetryBox';
    telemetryBox.className = 'video-telemetry-box';
    telemetryBox.innerHTML = `
      <div class="video-telemetry-header">
        <span class="video-telemetry-label" id="videoTelemetryLabel">⏳ Прогресс урока: 0%</span>
        <span class="video-telemetry-time" id="videoTelemetryTime">0 из -- мин</span>
      </div>
      <div class="video-telemetry-bar-wrap">
        <div class="video-telemetry-bar-fill" id="videoTelemetryFill" style="width: 0%;"></div>
      </div>
      <div class="video-telemetry-hint" id="videoTelemetryHint">
        ${dayNum === 4
          ? 'Посмотрите финальный урок для целостного понимания всей системы натальной карты.'
          : 'Проверочный вопрос доступен ниже. Выберите ваш вариант для закрепления материала и получения чек-листа.'}
      </div>
    `;
    const wrapper = card.querySelector('.inline-video-wrapper') || video.parentElement;
    if (wrapper && wrapper.nextSibling) {
      card.insertBefore(telemetryBox, wrapper.nextSibling);
    } else {
      card.appendChild(telemetryBox);
    }
  }

  // 2. Создаем или находим контейнер проверочного вопроса (только для Дней 1, 2, 3)
  let quizBox = document.getElementById('lessonQuizCard');
  if (!quizBox && quiz && dayNum !== 4) {
    quizBox = document.createElement('section');
    quizBox.id = 'lessonQuizCard';
    quizBox.className = 'card lesson-quiz-card';
    const isCompletedAlready = localStorage.getItem(storageCompletedKey) === 'true';
    quizBox.style.display = isCompletedAlready ? 'block' : 'none';

    if (!isRegistered()) {
      quizBox.innerHTML = `
        <div class="block-label" style="display: flex; align-items: center; gap: 6px; color: #1A8754;">
          <span>🎯</span> <span>${quiz.title}</span>
        </div>
        <div class="quiz-locked-notice" style="background: #FAF8F5; border: 1.5px dashed rgba(212, 175, 110, 0.45); border-radius: 14px; padding: 18px 14px; text-align: center; margin-top: 10px;">
          <div style="font-size: 26px; margin-bottom: 6px;">🔒</div>
          <div style="font-size: 13.5px; font-weight: 700; color: #260C14; margin-bottom: 4px;">Чек-лист и проверочный вопрос доступны участникам</div>
          <div style="font-size: 12px; color: #5C5857; line-height: 1.45; margin-bottom: 12px;">
            Зарегистрируйтесь бесплатно, чтобы смотреть уроки и скачивать материалы после просмотра.
          </div>
          <button type="button" class="btn-emerald" style="height: 44px; font-size: 13px; width: 100%; box-sizing: border-box; display: flex; align-items: center; justify-content: center; border: none; cursor: pointer; border-radius: 12px; font-weight: 700;" onclick="if (typeof window.openLeadModal === 'function') { window.openLeadModal(window.location.pathname); } else if (typeof window.handleTicketClick === 'function') { window.handleTicketClick(event); }">
            <span>Зарегистрироваться бесплатно →</span>
          </button>
        </div>
      `;
      card.parentElement.insertBefore(quizBox, card.nextSibling);
      return;
    }

    quizBox.innerHTML = `
      <div class="block-label" style="display: flex; align-items: center; gap: 6px; color: #1A8754;">
        <span>🎯</span> <span>${quiz.title}</span>
      </div>
      <h3 style="font-size: 16px; font-weight: 700; color: #260C14; margin: 8px 0 4px; line-height: 1.35;">
        ${quiz.question}
      </h3>
      <p style="font-size: 12.5px; color: var(--text-muted); margin-bottom: 14px;">
        ${quiz.subtitle}
      </p>
      <div class="lesson-quiz-options" id="lessonQuizOptions">
        ${quiz.options.map((opt, idx) => `
          <button type="button" class="quiz-option-btn" data-opt-id="${opt.id}" onclick="(window.submitLessonAnswer || window.MetaOnboarding?.submitLessonAnswer)(${dayNum}, '${opt.id}')">
            <span class="quiz-option-radio"></span>
            <span class="quiz-option-text">${opt.text}</span>
          </button>
        `).join('')}
      </div>
      <div class="lesson-checklist-result" id="lessonChecklistResult" style="display: none;">
        <div class="checklist-success-banner">
          <div style="font-size: 20px; margin-bottom: 4px;" id="checklistBannerIcon">🎁</div>
          <div style="font-size: 14px; font-weight: 800; color: #1A8754; margin-bottom: 2px;" id="checklistBannerTitle">
            Обучающий материал урока доступен к скачиванию:
          </div>
          <div style="font-size: 12px; color: #5C5857; margin-bottom: 12px;" id="checklistBannerSubtitle">
            ${quiz.checklist.title}
          </div>
          <a href="${quiz.checklist.url}" target="_blank" rel="noopener noreferrer" class="btn-download-checklist" download="${quiz.checklist.filename}">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>📥 Скачать чек-лист урока (PDF)</span>
          </a>
          ${(dayNum === 1 || dayNum === 2 || dayNum === 3) ? `
            <div style="margin-top: 14px; padding-top: 12px; border-top: 1px dashed rgba(26, 135, 84, 0.25);">
              <div style="font-size: 12px; font-weight: 700; color: #260C14; margin-bottom: 6px;">
                🏛️ Хотите забронировать персональный разбор карты от автора?
              </div>
              <a href="/questionnaire.html" class="btn-emerald" style="height: 42px; font-size: 12.5px; width: 100%; box-sizing: border-box; display: flex; align-items: center; justify-content: center; text-decoration: none;">
                <span>Заполнить анкету предзаписи на курс →</span>
              </a>
            </div>
          ` : ''}
        </div>
      </div>
    `;
    card.parentElement.insertBefore(quizBox, card.nextSibling);

    // Прямая привязка кликов для надежности
    quizBox.querySelectorAll('.quiz-option-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        const optId = this.getAttribute('data-opt-id');
        submitLessonAnswer(dayNum, optId);
      });
    });

    // Восстанавливаем сохраненный ответ, если он уже был дан
    const savedAnswer = localStorage.getItem(storageAnsweredKey);
    if (savedAnswer) {
      renderAnsweredState(dayNum, savedAnswer);
    }
  }

  // 3. Восстановление позиции воспроизведения (Resume Playback)
  function restoreSavedPosition() {
    try {
      const savedPos = parseFloat(localStorage.getItem(storagePosKey) || '0');
      if (savedPos > 10 && video.duration > 60 && savedPos < (video.duration - 20)) {
        video.currentTime = savedPos;
      }
    } catch (e) {}
  }

  if (video.readyState >= 1) {
    restoreSavedPosition();
  } else {
    video.addEventListener('loadedmetadata', restoreSavedPosition, { once: true });
  }

  // 4. Обновление прогресс-бара и проверка 75% порога
  let lastSaveTime = 0;

  function updateProgress() {
    const duration = video.duration || 0;
    const pureWatched = calculatePureWatchedSeconds(video);

    // Запоминаем максимальный накопленный прогресс
    const prevSavedPure = parseFloat(localStorage.getItem(storagePureKey) || '0');
    const effectivePure = Math.max(pureWatched, prevSavedPure);
    if (pureWatched > prevSavedPure) {
      try { localStorage.setItem(storagePureKey, String(Math.floor(pureWatched))); } catch (e) {}
    }

    const pct = duration > 0 ? Math.min(100, Math.floor((effectivePure / duration) * 100)) : 0;
    const isCompletedAlready = localStorage.getItem(storageCompletedKey) === 'true';
    const isThresholdPassed = (pct >= 75) || isCompletedAlready;

    const fillEl = document.getElementById('videoTelemetryFill');
    const labelEl = document.getElementById('videoTelemetryLabel');
    const timeEl = document.getElementById('videoTelemetryTime');
    const hintEl = document.getElementById('videoTelemetryHint');
    const markBtn = document.getElementById('markCompletedBtn');
    const compBadge = document.getElementById('completedBadge');

    if (fillEl) fillEl.style.width = `${Math.min(100, Math.max(pct, isCompletedAlready ? 100 : 0))}%`;
    if (labelEl) {
      labelEl.innerHTML = isThresholdPassed ? '✓ Урок усвоен (75%+)' : `⏳ Прогресс: ${pct}% из 75%`;
      labelEl.style.color = isThresholdPassed ? '#1A8754' : '#5C5857';
    }
    if (timeEl && duration > 0) {
      timeEl.textContent = `${formatMinutesAndSeconds(effectivePure)} из ${formatMinutesAndSeconds(duration)} мин`;
    }

    // Обновляем визуальное состояние кнопки завершения урока
    if (isCompletedAlready) {
      if (markBtn) markBtn.style.display = 'none';
      if (compBadge) compBadge.style.display = 'block';
    } else if (markBtn) {
      if (isThresholdPassed) {
        markBtn.classList.remove('btn-locked-progress');
        markBtn.classList.add('btn-ready-progress');
        const markText = document.getElementById('markCompletedBtnText');
        if (markText) markText.textContent = '✔ Отметить урок как пройден';
      } else {
        markBtn.classList.add('btn-locked-progress');
        markBtn.classList.remove('btn-ready-progress');
        const markText = document.getElementById('markCompletedBtnText');
        if (markText) markText.textContent = `⏳ Досмотрите урок (${pct}% из 75%)`;
      }
    }

    // Если порог 75% достигнут - открываем проверочный вопрос
    if (isThresholdPassed) {
      if (quizBox) {
        quizBox.style.display = 'block';
      }
      if (hintEl) {
        hintEl.innerHTML = dayNum === 4
          ? '<span style="color: #1A8754; font-weight: 700;">✓ Финальный урок усвоен!</span> Ниже доступны спецпредложения и анкета предзаписи.'
          : '<span style="color: #1A8754; font-weight: 700;">✓ Отлично! 75% урока просмотрено.</span> Ответьте на вопрос ниже, чтобы зафиксировать прохождение и забрать чек-лист.';
      }
      sendVideoTelemetry(dayNum, 'video_completed_75', { pure_seconds: effectivePure, duration });
      // Если ответ уже был дан ранее - подсвечиваем его
      const savedAnswer = localStorage.getItem(storageAnsweredKey);
      if (savedAnswer) {
        renderAnsweredState(dayNum, savedAnswer);
      }
    } else {
      if (quizBox && !isCompletedAlready) {
        quizBox.style.display = 'none';
      }
      if (hintEl) {
        hintEl.innerHTML = dayNum === 4
          ? 'Посмотрите финальный урок (минимум 75%), чтобы зачесть марафон.'
          : 'Посмотрите минимум 75% урока, чтобы открыть проверочный вопрос и забрать чек-лист.';
      }
      if (pct >= 50) {
        sendVideoTelemetry(dayNum, 'video_progress_50', { pure_seconds: effectivePure, duration });
      } else if (pct >= 25) {
        sendVideoTelemetry(dayNum, 'video_progress_25', { pure_seconds: effectivePure, duration });
      } else if (effectivePure >= 10) {
        sendVideoTelemetry(dayNum, 'video_started', { pure_seconds: effectivePure, duration });
      }
    }

    // Сохранение позиции каждые 10 секунд
    const nowTs = Date.now();
    if (nowTs - lastSaveTime > 10000 && video.currentTime > 5) {
      lastSaveTime = nowTs;
      try { localStorage.setItem(storagePosKey, String(Math.floor(video.currentTime))); } catch (e) {}
    }
  }

  video.addEventListener('timeupdate', updateProgress);
  video.addEventListener('ended', () => {
    try { localStorage.removeItem(storagePosKey); } catch (e) {}
    updateProgress();
  });

  // Запуск первичного рендера
  updateProgress();
}

// Отображение состояния сданного теста и выдачи чек-листа
function renderAnsweredState(dayNum, selectedOptionId) {
  const quiz = LESSON_QUIZZES[dayNum];
  if (!quiz) return;

  const optionsContainer = document.getElementById('lessonQuizOptions');
  const resultContainer = document.getElementById('lessonChecklistResult');

  if (optionsContainer) {
    const btns = optionsContainer.querySelectorAll('.quiz-option-btn');
    btns.forEach(btn => {
      if (btn.getAttribute('data-opt-id') === selectedOptionId) {
        btn.classList.add('is-selected');
        const radio = btn.querySelector('.quiz-option-radio');
        if (radio) radio.innerHTML = '✓';
        btn.style.opacity = '1';
      } else {
        btn.classList.remove('is-selected');
        const radio = btn.querySelector('.quiz-option-radio');
        if (radio) radio.innerHTML = '';
        btn.style.opacity = '0.75';
      }
    });
  }

  if (resultContainer) {
    let customTip = 'Поздравляем с прохождением урока! Сохраните обучающий материал для самостоятельной практики.';
    let nextDayUrl = '/dashboard.html';
    let nextDayText = 'В личный кабинет';

    if (dayNum === 1) {
      customTip = 'Рекомендуем сразу открыть PDF чек-лист: в нем простыми словами описано, как сбалансировать свои стихии, восстановить энергию и снять напряжение в теле.';
      nextDayUrl = '/day-2.html';
      nextDayText = 'Перейти ко 2 уроку';
    } else if (dayNum === 2) {
      customTip = 'Рекомендуем сохранить PDF чек-лист: в нем собраны простые правила понимания партнера, укрепления близости и защиты личных границ.';
      nextDayUrl = '/day-3.html';
      nextDayText = 'Перейти к 3 уроку';
    } else if (dayNum === 3) {
      customTip = 'Рекомендуем открыть PDF чек-лист: в нем пошагово разобрано, как убрать страх нехватки денег и разрешить себе достойный доход.';
      nextDayUrl = '/day-4.html';
      nextDayText = 'Перейти к 4 уроку (Финал)';
    } else if (dayNum === 4) {
      customTip = 'Поздравляем с завершением 4-дневного марафона! Теперь вы знаете, как натальная карта помогает управлять здоровьем, отношениями и деньгами.';
      nextDayUrl = '/questionnaire.html';
      nextDayText = 'Заполнить анкету предзаписи на курс';
    }

    resultContainer.style.display = 'block';
    resultContainer.innerHTML = `
      <div class="checklist-success-banner" style="background: #F4FAF6; border: 1.5px solid #22A96B; border-radius: 16px; padding: 18px 14px; text-align: center; margin-top: 14px; box-shadow: 0 4px 18px rgba(34, 169, 107, 0.12);">
        <div style="font-size: 26px; margin-bottom: 4px;">🎉</div>
        <div style="font-size: 15px; font-weight: 800; color: #1A8754; margin-bottom: 6px;">
          Ответ принят! Урок ${dayNum} успешно пройден.
        </div>
        <div style="font-size: 12.5px; color: #3D3935; line-height: 1.5; margin-bottom: 14px; padding: 0 4px;">
          ${customTip}
        </div>
        <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px;">
          <a href="${quiz.checklist.url}" target="_blank" rel="noopener noreferrer" class="btn-download-checklist" download="${quiz.checklist.filename}" style="width: 100%; box-sizing: border-box; display: flex; align-items: center; justify-content: center; gap: 8px; height: 44px; text-decoration: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            <span>📥 Открыть PDF чек-лист урока</span>
          </a>

        </div>

        <!-- Кнопка перехода сразу под тестом -->
        <div style="padding-top: 12px; border-top: 1px dashed rgba(26, 135, 84, 0.3);">
          <a href="${nextDayUrl}" class="btn-emerald" style="width: 100%; height: 46px; font-size: 13.5px; font-weight: 800; display: flex; align-items: center; justify-content: center; gap: 8px; text-decoration: none; border-radius: 12px;">
            <span>${nextDayText}</span>
            <span>→</span>
          </a>
        </div>
      </div>
    `;

    // Скрываем второстепенные блоки инструкций и длинные промо-блоки после ответа, чтобы не загромождать экран
    try {
      const blocksToHide = document.querySelectorAll(
        '.sotis-instruction-card, .questionnaire-promo-card, .btn-complete-block, .day-pagination-row'
      );
      blocksToHide.forEach(el => {
        el.style.display = 'none';
      });
    } catch (e) {}
  }

  // Обновляем бейдж "Отметить как просмотрено"
  const markBtn = document.getElementById('markCompletedBtn');
  const compBadge = document.getElementById('completedBadge');
  if (markBtn && compBadge) {
    markBtn.style.display = 'none';
    compBadge.style.display = 'block';
  }
}

// Отправка клиентских событий телеметрии в базу данных CRM
function sendVideoTelemetry(dayNum, eventType, details = {}) {
  try {
    const key = `meta_evt_${dayNum}_${eventType}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, 'true');

    // Яндекс.Метрика: фиксация ключевых видео-целей
    if (typeof trackGoal === 'function') {
      if (eventType === 'video_started') {
        trackGoal('video_start', { day: Number(dayNum) });
        trackGoal(`day${dayNum}_view`, { day: Number(dayNum) });
      } else if (eventType === 'video_completed_75') {
        trackGoal('video_completed_75', { day: Number(dayNum) });
        trackGoal(`day${dayNum}_completed`, { day: Number(dayNum) });
      }
    }

    const u = (typeof getUser === 'function' ? getUser() : {}) || {};
    fetch('/api/activity/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: u.id || '',
        telegram_id: u.telegramId || '',
        event_type: eventType,
        day_number: Number(dayNum),
        details: { ...details, day: dayNum }
      })
    }).catch(() => {});
  } catch (e) {}
}

// Отправка ответа на бэкенд в SQLite базу данных
function submitLessonAnswer(dayNumber, optionId) {
  try {
    if (typeof triggerHaptic === 'function') triggerHaptic('medium');
  } catch (e) {}

  const dayNum = Number(dayNumber);
  const quiz = LESSON_QUIZZES[dayNum];
  if (!quiz) return;

  const option = quiz.options.find(o => o.id === optionId);
  const optText = option ? option.text : optionId;

  // Яндекс.Метрика: цель ответа на проверочный вопрос
  if (typeof trackGoal === 'function') {
    trackGoal('quiz_answer_submit', { day: dayNum, option: optionId });
  }

  // 1. Немедленно обновляем UI и сохраняем локально
  try {
    localStorage.setItem(`meta_day_${dayNum}_answered`, optionId);
    localStorage.setItem(`meta_day_${dayNum}_completed`, 'true');
  } catch (e) {}

  renderAnsweredState(dayNum, optionId);
  markLessonCompleted(dayNum);

  // 2. Отправляем в API сервера (с сохранением в lesson_answers и user_activity_logs)
  try {
    const u = (typeof getUser === 'function' ? getUser() : {}) || {};
    const payload = {
      day: dayNum,
      question_id: `day_${dayNum}_q1`,
      answer: optText,
      telegram_id: u.telegram_id || u.telegramId || localStorage.getItem('meta_tg_user_id') || '',
      user_id: u.id || '',
      name: u.name || '',
      phone: u.phone || ''
    };

    fetch('/api/lesson/answer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  } catch (err) {
    console.warn('[VideoTracking] Failed to sync lesson answer:', err);
  }
}

// Завершение урока и перевод кнопки в выполненное состояние
function markLessonCompleted(dayNum) {
  const d = Number(dayNum);
  try {
    localStorage.setItem(`meta_day_${d}_completed`, 'true');
    if (!localStorage.getItem(`meta_day_${d}_completed_at`)) {
      localStorage.setItem(`meta_day_${d}_completed_at`, new Date().toISOString());
    }
    if (typeof triggerHaptic === 'function') triggerHaptic('success');
  } catch (e) {}

  const btn = document.getElementById('markCompletedBtn');
  const badge = document.getElementById('completedBadge');
  if (btn) btn.style.display = 'none';
  if (badge) badge.style.display = 'block';

  // Обновляем шкалу телеметрии
  const fillEl = document.getElementById('videoTelemetryFill');
  const labelEl = document.getElementById('videoTelemetryLabel');
  if (fillEl) fillEl.style.width = '100%';
  if (labelEl) {
    labelEl.innerHTML = '✓ Урок успешно пройден!';
    labelEl.style.color = '#1A8754';
  }

  if (typeof trackGoal === 'function') {
    trackGoal(`day${d}_completed`, { day: d });
  }

  // Фиксируем завершение урока на сервере для пересчета drip-доступа и планирования рассылки
  try {
    const u = (typeof getUser === 'function' ? getUser() : {}) || {};
    fetch('/api/activity/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: u.id || '',
        telegram_id: u.telegram_id || u.telegramId || localStorage.getItem('meta_tg_user_id') || '',
        event_type: 'lesson_completed',
        day_number: d,
        details: {
          day: d,
          completed_at: new Date().toISOString()
        }
      })
    }).catch(() => {});
  } catch (err) {}

  // Обновляем статус в кабинете, если открыт
  if (typeof updateDashboardDaysUI === 'function') {
    updateDashboardDaysUI();
  }
}

// Всплывающее предупреждение при попытке завершить недосмотренный урок
function showVideoWarningNotification(message) {
  let toast = document.getElementById('metaVideoNoticeToast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'metaVideoNoticeToast';
    toast.className = 'meta-video-toast';
    document.body.appendChild(toast);
  }
  toast.innerHTML = `
    <div style="display: flex; align-items: flex-start; gap: 10px;">
      <span style="font-size: 20px; line-height: 1;">⚠️</span>
      <div style="flex: 1; font-size: 13px; line-height: 1.45; color: #260C14;">
        ${message}
      </div>
    </div>
  `;
  toast.classList.add('is-visible');

  // Встряхиваем блок телеметрии плеера
  const tBox = document.getElementById('videoWatchTelemetryBox');
  if (tBox) {
    tBox.classList.remove('telemetry-shake');
    void tBox.offsetWidth;
    tBox.classList.add('telemetry-shake');
  }

  try {
    if (typeof triggerHaptic === 'function') triggerHaptic('warning');
  } catch(e) {}

  setTimeout(() => {
    if (toast) toast.classList.remove('is-visible');
  }, 4500);
}

// Единая валидация кнопки «Отметить как просмотрено» для всех дней
function toggleCompleted(dayNumber) {
  const path = window.location.pathname;
  let d = Number(dayNumber);
  if (!d) {
    if (path.includes('day-1')) d = 1;
    else if (path.includes('day-2')) d = 2;
    else if (path.includes('day-3')) d = 3;
    else if (path.includes('day-4')) d = 4;
    else d = 1;
  }

  // Если уже завершен
  if (localStorage.getItem(`meta_day_${d}_completed`) === 'true') {
    markLessonCompleted(d);
    return true;
  }

  const video = document.querySelector('video') || document.getElementById(`day${d}InlineVideo`);
  const duration = video?.duration || 0;
  const pureWatched = calculatePureWatchedSeconds(video);
  const prevSavedPure = parseFloat(localStorage.getItem(`meta_video_pure_day_${d}`) || '0');
  const effectivePure = Math.max(pureWatched, prevSavedPure);
  const pct = duration > 0 ? Math.min(100, Math.floor((effectivePure / duration) * 100)) : 0;

  // Проверка порога 75%
  if (pct < 75) {
    const neededSec = Math.max(0, Math.ceil(duration * 0.75 - effectivePure));
    const neededMinText = neededSec > 0 ? ` (осталось ${formatMinutesAndSeconds(neededSec)} мин)` : '';
    showVideoWarningNotification(
      `Вы просмотрели только <strong>${pct}%</strong> урока. Досмотрите минимум <strong>75%</strong> видео${neededMinText}, чтобы зачесть урок и получить чек-лист!`
    );
    return false;
  }

  // 75% набрано!
  // Для дней 1, 2, 3: проверяем, ответил ли на вопрос
  if (d !== 4) {
    const answered = localStorage.getItem(`meta_day_${d}_answered`);
    if (!answered) {
      const qBox = document.getElementById('lessonQuizCard');
      if (qBox) {
        qBox.style.display = 'block';
        qBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        qBox.classList.remove('quiz-pulse-highlight');
        void qBox.offsetWidth;
        qBox.classList.add('quiz-pulse-highlight');
      }
      showVideoWarningNotification(
        `Отлично, 75% видео просмотрено! Теперь <strong>выберите ваш вариант ответа</strong> на проверочный вопрос ниже, чтобы зачесть урок и забрать чек-лист.`
      );
      return false;
    }
  }

  // Если ответил или это День 4
  markLessonCompleted(d);
  return true;
}

// Экспорт глобально
window.initVideoTracking = initVideoTracking;
window.submitLessonAnswer = submitLessonAnswer;
window.sendVideoTelemetry = sendVideoTelemetry;
window.markLessonCompleted = markLessonCompleted;
window.showVideoWarningNotification = showVideoWarningNotification;
window.toggleCompleted = toggleCompleted;
window.videoTrackingToggleCompleted = toggleCompleted;

if (window.MetaOnboarding) {
  window.MetaOnboarding.initVideoTracking = initVideoTracking;
  window.MetaOnboarding.submitLessonAnswer = submitLessonAnswer;
  window.MetaOnboarding.markLessonCompleted = markLessonCompleted;
  window.MetaOnboarding.toggleCompleted = toggleCompleted;
}